import React, { useRef, useEffect, useState } from 'react';
import './Sidebar.css';

const Sidebar = ({ children, tabs, activeTab, onTabChange, width = 350, onWidthChange, topOffset = 80 }) => {
  const hasContent = children && activeTab !== null;
  const [isDragging, setIsDragging] = useState(false);
  const sidebarRef = useRef(null);
  const dragHandleRef = useRef(null);

  const minWidth = 300;
  const maxWidth = 800;

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging) return;
      
      const newWidth = window.innerWidth - e.clientX;
      const clampedWidth = Math.max(minWidth, Math.min(maxWidth, newWidth));
      onWidthChange(clampedWidth);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
  }, [isDragging, onWidthChange]);

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const contentWidth = width - 48; // Subtract tab width
  const closedTransform = `translateX(${width - 48}px)`; // Show only tabs when closed

  return (
    <div 
      ref={sidebarRef}
      className={`sidebar-container ${hasContent ? 'active' : ''}`}
      style={{ 
        width: `${width}px`,
        top: topOffset > 0 ? `${topOffset}px` : '0',
        transform: hasContent ? 'translateX(0)' : closedTransform
      }}
    >
      <div className="sidebar-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`sidebar-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(activeTab === tab.id ? null : tab.id)}
            title={tab.label}
            aria-label={tab.label}
          >
            {tab.icon}
          </button>
        ))}
      </div>
      {hasContent && (
        <>
          <div
            ref={dragHandleRef}
            className={`sidebar-drag-handle ${isDragging ? 'dragging' : ''}`}
            onMouseDown={handleMouseDown}
          />
          <div 
            className="sidebar-content"
            style={{ width: `${contentWidth}px` }}
          >
            {children}
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
